import React, { useEffect, useState, useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import FormContext from '../../helpers/formContext';
import ModeSwitcher from '../parts/form/ModeSwitcher';
import { MdModeEdit } from "react-icons/md";
import PaymentSchedules from '../parts/PaymentSchedules';
import PaymentMethods from '../parts/PaymentMethods';
import PaymentTypes from '../parts/PaymentTypes';
import FormInputs from '../parts/form/FormInputs';

export default function SponsorshipTemplate(){
    const {
        inputCustomAmount,
        checkOut,
        displayAmountHandles,
        displaySelectedFrequency,
        getFormatAmount,
        inputChange,
        enums,
        helpers,
        custom_amount, 
        selected_other_amount,
        formController,
        displayReviewFields,
        eye_mode, changeMode,
        form_data,
        site_options,
        loading,
        step,
        errors,
        removeErrors,
        images,
        Loader,
        RenderErrors,
        InputNumber,
        //FormInputs,
        InputCheckbox,
        addChildCount,
        removeChildCount,
        child_counter, 
        inputChildCounter,
        form_slug,
        displayAmountAddons
    } = useContext(FormContext);
    const [loaded, setLoaded] = useState(false);

    // useEffect(() => {
    //     setTimeout(() => {
    //         const scriptTag = document.createElement("script");
    //         scriptTag.src = "//js.hs-scripts.com/22233274.js?businessUnitId=1237950"
    //         scriptTag.id = "hs-script-loader"
    //         scriptTag.type = "text/javascript";
    //         scriptTag.async = true;
    //         scriptTag.defer = true;
    //         scriptTag.addEventListener('load', ()=>setLoaded(true));
    //         document.head.appendChild(scriptTag);
    //     },5000)
    // }, []);

    return (
        <>
            {step === 1 ?
            <div className="cf-form-column" style={{position: 'relative'}}>
                <Loader isLoading={loading} />
                <div id="your-donation" className="your-donation-form">
                    <div className="row d-flex align-items-start">
                        <div className="col-10 col-sm-10 col-md-11">
                            <h2 className='text-orange text-start text-center-md'>{site_options.form_heading ?? 'Your Donation'}</h2>
                        </div>

                        <div className='col-2 col-sm-2 col-md-1 d-flex justify-content-end'>
                            <ModeSwitcher
                                eye_mode={eye_mode}
                                changeMode={changeMode}
                            />
                        </div>
                    </div>
                    <form id="wv-donation-form" name={`wv-donate-${form_slug}`} className={`wv-donate-${form_slug}`} onSubmit={(e) => e.preventDefault()} >
                        <PaymentTypes />

                        <PaymentSchedules />
                                                                        
                        <PaymentMethods 
                            siteOptions={site_options} 
                            formData={form_data} 
                            inputChange={inputChange} 
                            errors={errors}
                        />

                        {displayAmountHandles()}

                        {selected_other_amount ?
                        <div className="row align-middle other-amount">
                            <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                <label className="large mb-0">Other Amount</label><br/>
                                <small>*&#8369;{form_data.payment_type == 1 ? site_options.min_onetime_amount : site_options.min_recurring_amount} minimum amount</small>
                            </div>
                            <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                                <InputNumber
                                    id={'input-amount'} 
                                    name={'amount'} 
                                    value={custom_amount}  
                                    placeholder="Enter Amount" 
                                    labelClass="form-label"
                                    tagClass="mb-0"
                                    onChange={inputCustomAmount}
                                    onFocus={removeErrors}
                                />
                            </div>
                        </div> : ''}

                        {displayAmountAddons()}

                        {/* Child Counter */}
                        {(site_options?.child_counter == 1 || site_options?.number_counter == 1) &&  form_data.payment_type == 2 ?
                        <div className="row mb-4">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                <label className="fs-6 child-counter-label">{site_options?.child_counter_label ? site_options?.child_counter_label : 'No. of Sponsored Children'}</label>
                            </div>
                            <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                                <div className="child-num">
                                    <InputNumber
                                        id={'input-child-counter'} 
                                        value={child_counter} 
                                        placeholder={ 'No of Child' } 
                                        tagClass="input-small form-control float-start input-counter input me-2"
                                        onChange={inputChildCounter}
                                        onFocus={removeErrors}
                                    />
                                    <button type='button' className="plus me-2 bg-orange text-light" onClick={addChildCount}>+</button>
                                    <button type='button' className="minus bg-orange text-light" onClick={removeChildCount}>-</button>
                                </div>
                            </div>
                        </div>: ""}

                        {/* {site_options.number_counter == 1 ?
                        <div className="row mb-4">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                <label className="fs-6 child-counter-label">{site_options.number_counter_label ?? 'Number'}</label>
                            </div>
                            <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                                <div className="child-num">
                                    <InputNumber
                                        id={'input-number-counter'} 
                                        value={number_counter} 
                                        placeholder={ 'No' } 
                                        tagClass="input-small form-control float-start input-counter input me-2"
                                        onChange={inputNumberCounter}
                                        onFocus={removeErrors}
                                    />
                                    <button type='button' className="plus me-2 bg-orange text-light" onClick={addNumberCount}>+</button>
                                    <button type='button' className="minus bg-orange text-light" onClick={removeNumberCount}>-</button>
                                </div>
                            </div>
                        </div>: ""} */}

                        <div className="row d-flex align-items-center">
                            <div className="col-4">
                                <label className="large">Total Amount</label>
                            </div>
                            <div className="col-8">
                                <h4 className='mb-1 fs-1 total-amount'>&#8369;{getFormatAmount(form_data.amount)}</h4>
                                <h4 className='fs-4 mb-0 text-secondary selected-frequency'>{displaySelectedFrequency()}</h4>
                                <RenderErrors 
                                    errors={errors} 
                                    name="amount"
                                    className="text-error fs-7"
                                />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h2>Personal Information</h2>
                            </div>
                        </div>

                        <FormInputs 
                            inputChange={inputChange}
                            removeErrors={removeErrors}
                            errors={errors}
                            hide={['sponsorship_location','sponsorship_gender','sponsorship_age', 'sponsorship_age_range','sponsorship_motivation']}
                        />

                        <div className="row mb-2">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h2>Choose Your Sponsored Child</h2>
                            </div>
                        </div>
                        
                        <FormInputs 
                            inputChange={inputChange}
                            removeErrors={removeErrors}
                            show={['sponsorship_location','sponsorship_gender','sponsorship_age', 'sponsorship_age_range','sponsorship_motivation']}
                            showLabel={true}
                        />

                        <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className="confirm-box">
                                <InputCheckbox
                                id="agree_to_privacy_policys"
                                name="agree_to_privacy_policy"
                                value={1}
                                onChange={inputChange}
                                checked = {form_data.agree_to_privacy_policy}
                                tagClass='me-2'
                                label={<>I have read and understood the World Vision Development Foundation Inc. website <a href="https://www.worldvision.org.ph/terms-of-use/" className="text-orange" target="_blank">terms of use</a> and <a href="https://www.worldvision.org.ph/privacy-notice/" className="text-orange" target="_blank">data privacy policy.</a></>}
                                labelClass="ms-0"
                                />
                                
                                <RenderErrors 
                                    errors={errors} 
                                    name="agree_to_privacy_policy"
                                    className="text-error fs-7"
                                />
                            </div>
                            
                            {/* <div className="mt-2" style={{fontSize: '12px'}}>{dswd_permit}</div> */}
                        </div>
                        </div>


                        <div className='row text-center'>
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                {
                                    site_options.form_type === 'standard' ?  
                                    <button type="submit" className="btn-submit mt-3" onClick={(e) => formController(2)} id="donate-review-btn" name="donate-review-btn">Review Details</button>
                                    : ''
                                }
                                {
                                    site_options.form_type === 'direct-checkout' ?  
                                    <button type="submit" className="btn-submit mt-3" onClick={(e) => formController(2)} id="donate-payment-btn" name="donate-payment-btn">Donate</button>
                                    : ''
                                }
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <img src={images.sslCheckout} />
                            </div>
                        </div>
                    </form>
                </div> {/* #your-donation */}
            </div> : ""}
            
            {site_options.form_type === 'standard' && step === 2 ?
            <div className="cf-review-column" style={{position: 'relative'}}>
                <Loader isLoading={loading} />
                <div id="your-donation" className="your-donation-form">
                    <div className="row d-flex align-items-start">
                        <div className="col-10 col-sm-10 col-md-11">
                            <h2 className='text-orange text-start text-center-md'>Review Details</h2>
                        </div>

                        <div className='col-2 col-sm-2 col-md-1 d-flex justify-content-end'>
                            <ModeSwitcher
                                eye_mode={eye_mode}
                                changeMode={changeMode}
                            />
                        </div>
                    </div>
                        
                        <div className="row">
                            {
                                displayReviewFields()
                            }
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <label className="form-label">Payment Type</label>
                                <h4 className='fw-bold text-break mb-0 form-value'>{enums.paymentType(form_data.payment_type)}</h4>
                            </div>

                            <div className="col-lg-6">
                                <label className="form-label">Payment Frequency</label>
                                <h4 className='fw-bold text-break mb-0 form-value'>{helpers.ucwords(enums.paymentFrequency(form_data.payment_frequency, '---'))}</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <label className="form-label">Giving Method</label>
                                <h4 className='fw-bold text-break mb-0 form-value'>{enums.paymentMethods(form_data.payment_method)}</h4>
                            </div>

                            {
                                form_data.addon_items ?
                                <div className="col-lg-6">
                                    <label className="form-label">Add-on</label>
                                    <h4 className='fw-bold text-break mb-0 form-value'>{helpers.formatAddons(form_data.addon_items, 'label')}</h4>
                                </div> : ''
                            }

                            <div className="col-lg-6">
                                <label className="form-label">Total Amount</label>
                                <h4 className='fw-bold text-break mb-0 form-value'>&#8369;{getFormatAmount(form_data.amount)}</h4>
                            </div>
                        </div>

                        <hr/>
                        
                        
                        <div className="row text-center">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3 mb-3">
                                <button type='button' className='btn fs-5 text-orange' href="#" onClick={(e) => formController(1)} id="donate-update-btn" name="donate-update-btn"><MdModeEdit /> Update Entry</button>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <button type="button" className="btn-submit mt-3" onClick={(e) => checkOut()} id="donate-payment-btn" name="donate-payment-btn">Donate</button>
                                <br/>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <img src={images.sslCheckout} />
                            </div>
                        </div>
                </div>
            </div> : ""
            }
        </>
    )
}
